import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { registerServiceWorker, unregisterServiceWorker } from './utils/serviceWorkerRegistration';

try {
  if (import.meta.env.DEV) {
    unregisterServiceWorker();
  }

  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>
  );

  if (!import.meta.env.DEV) {
    registerServiceWorker();
  }
} catch (error) {
  console.error('App failed to render:', error);
  document.getElementById('root').innerHTML = `
    <div style="padding: 20px; text-align: center; font-family: system-ui;">
      <h1>Something went wrong</h1>
      <p>Please try refreshing the page or using a different browser.</p>
      <p style="color: red; font-size: 12px;">${error.message}</p>
    </div>
  `;
}
